import { RefObject, useEffect, useState } from 'react';

interface IUseElementScrolledToTop {
  isScrolledToTop: boolean;
}

interface IUseElementScrolledToTopOptionsProp {
  scrollOffset?: number;
}

export const useElementScrolledToTop = <T extends HTMLElement>(
  ref: RefObject<T>,
  options?: IUseElementScrolledToTopOptionsProp,
): IUseElementScrolledToTop => {
  const [isScrolledToTop, setIsScrolledToTop] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        const { scrollTop, scrollHeight, clientHeight } = ref.current;

        const hasScrollbar = scrollHeight > clientHeight;

        setIsScrolledToTop(
          hasScrollbar && scrollTop <= (options?.scrollOffset ?? 10),
        );
      }
    };
    const element = ref.current;

    if (element) {
      element.addEventListener('scroll', handleScroll);
      handleScroll();
    }

    return () => {
      if (element) {
        element.removeEventListener('scroll', handleScroll);
      }
    };
  }, [ref, options?.scrollOffset]);

  return { isScrolledToTop };
};
